import { reportError } from 'utils/error'

/**
 * Sets data to local storage
 *
 * @param {string} key Local storage key
 * @param {Object} data Data object to be stored in local storage
 * @param {boolean} [overwrite=false] True to overwrite existing data, if key exists. Otherwise defaults to safely append new data values only.
 */
export const setLocalStorage = (key: string, data: { [key: string]: any }, overwrite: boolean = false) => {
  try {
    const item = localStorage.getItem(key)
    const value = JSON.stringify(!!item && !overwrite ? { ...JSON.parse(item), ...data } : data)
    localStorage.setItem(key, value)
  } catch (e) {
    reportError(new Error('setLocalStorage error'), { severity: 'info', metaData: e as Error })
  }
}
